import angular from 'angular';

export const stacksModule = angular.module(
  'portainer.app.react.components.stacks',
  []
).name;
